// CodeReviewDanyDone: Change to ts
import type {PayloadAction} from '@reduxjs/toolkit';
import type {LanguageData, StateProps} from './language-selector.types';

export const langSelectorReducers = {
  setPmwLangs: (state: StateProps, action: PayloadAction<Array<LanguageData>>) => {
    state.pmwLangs = action.payload;
  },
};
